import React from 'react';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { gql, graphql } from 'react-apollo';

import Loader from '../../components/Loader';
import PremiumListing from '../../components/Home/PremiumListing';
import RecommendListing from '../../components/Home/RecommendListing';
import NewListing from '../../components/Home/NewListing';
import MostViewedListing from '../../components/Home/MostViewedListing';
import PopularLocation from '../../components/Home/PopularLocation';
import ImageBanner from '../../components/Home/ImageBanner';
import StaticInfoBlock from '../../components/Home/StaticInfoBlock';
import HomeBanner from '../../components/Home/HomeBanner';
import HomeMapSection from '../../components/Home/HomeMapSection/HomeMapSection';
import MarketingBannerPopup from '../../components/Home/MarketingBannerPopup';
import FiveStarReviews from '../../components/Home/FiveStarReviews';
import CategorySelector from '../../components/CategorySelector';

import { closeWishListModal } from '../../actions/WishList/modalActions';
import { getActiveCategory } from '../../reducers/category';

// SEO
import JsonLd from '../../components/SEO/JsonLd';

import s from './Home.css';
import l from '../../components/Skeleton/Skeleton.css';

// Module component mapping
const MODULE_COMPONENTS = {
  homeBanner: HomeBanner,
  premiumListing: PremiumListing,
  recommendListing: RecommendListing,
  newListing: NewListing,
  mostViewedListing: MostViewedListing,
  popularLocation: PopularLocation,
  imageBanner: ImageBanner,
  staticInfoBlock: StaticInfoBlock,
  homeMapSection: HomeMapSection,
  fiveStarReviews: FiveStarReviews,
};

// Skeleton Loader
class Homepage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sliderArray: [1, 2, 3, 4],
      showBanner: true
    };
  }

  componentDidMount() {
    this.setState({ isLoad: false });
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
  }

  componentWillUnmount() {
    const { closeWishListModal } = this.props;
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      window.removeEventListener('resize', this.handleResize);
    }
    closeWishListModal();
  }

  handleResize = (e) => {
    let isBrowser, tabView;
    isBrowser = typeof window !== 'undefined';
    tabView = isBrowser ? window.matchMedia('(max-width: 1200px)').matches : false;
    this.setState({
      sliderArray: tabView ? [1, 2, 3] : [1, 2, 3, 4],
    });
  }

  handleCloseBanner = () => {
    this.setState({ showBanner: false });
  }

  renderModule = (module) => {
    const { layoutType, wholeData } = this.props;
    const Component = MODULE_COMPONENTS[module.id];

    if (!Component) return null;

    // Special props for certain modules
    const moduleProps = {};

    if (module.id === 'homeBanner') {
      moduleProps.layoutType = layoutType;
      moduleProps.wholeData = wholeData;
    }

    if (['premiumListing', 'recommendListing', 'newListing', 'mostViewedListing', 'popularLocation'].includes(module.id)) {
      moduleProps.skeletonArray = this.state.sliderArray;
      moduleProps.activeCategory = this.props.activeCategory;
    }

    return <Component key={module.id} {...moduleProps} />;
  };

  render() {
    const { layoutType } = this.props;
    const { wholeData, marketingBanner, homeModules } = this.props;
    const { showBanner } = this.state;

    if (!wholeData) return <Loader type="text" />;

    // Get modules config, sorted by order, filtered by enabled
    const modules = homeModules && homeModules.getHomeModulesSettings && homeModules.getHomeModulesSettings.modules
      ? homeModules.getHomeModulesSettings.modules
        .filter(m => m.enabled)
        .sort((a, b) => a.order - b.order)
      : null;

    // SEO: LocalBusiness Schema for homepage
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Navega - Boat Rentals",
      "image": "https://www.navegaapp.com/images/logo.png",
      "description": "Plataforma de alquiler de botes y yates en Miami y el Caribe. Reserva online, pago seguro, capitanes certificados.",
      "priceRange": "$$$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Miami Beach",
        "addressLocality": "Miami",
        "addressRegion": "FL",
        "postalCode": "33139",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 25.7617,
        "longitude": -80.1918
      },
      "url": "https://www.navegaapp.com",
      "telephone": "+1-305-000-0000",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [
        "https://www.facebook.com/navegaapp",
        "https://www.instagram.com/navegaapp",
        "https://twitter.com/navegaapp"
      ]
    };

    return (
      <div className={s.root}>
        {/* SEO: LocalBusiness JSON-LD */}
        <JsonLd data={localBusinessSchema} />

        {modules ? (
          // Dynamic rendering based on admin config
          modules.map(module => this.renderModule(module))
        ) : (
          // Fallback to default order if no config
          <>
            <HomeBanner layoutType={layoutType} wholeData={wholeData} />
            <PremiumListing skeletonArray={this.state.sliderArray} activeCategory={this.props.activeCategory} />
            <NewListing skeletonArray={this.state.sliderArray} activeCategory={this.props.activeCategory} />
            <RecommendListing skeletonArray={this.state.sliderArray} activeCategory={this.props.activeCategory} />
            <MostViewedListing skeletonArray={this.state.sliderArray} activeCategory={this.props.activeCategory} />
            <PopularLocation activeCategory={this.props.activeCategory} />
            <ImageBanner />
            <StaticInfoBlock />
            <HomeMapSection activeCategory={this.props.activeCategory} />
          </>
        )}

        {/* Ad Server v2: Show banner only if campaignStatus is ACTIVE */}
        {marketingBanner && marketingBanner.getMarketingBanner &&
          marketingBanner.getMarketingBanner.campaignStatus === 'ACTIVE' && (
            <MarketingBannerPopup
              show={showBanner}
              onHide={this.handleCloseBanner}
              banner={marketingBanner.getMarketingBanner}
            />
          )
        }
      </div>
    );
  }
}

const mapState = (state) => ({
  activeCategory: getActiveCategory(state),
});

const mapDispatch = {
  closeWishListModal
};

export default compose(
  injectIntl,
  withStyles(s, l),
  connect(mapState, mapDispatch),
  graphql(gql`
    query getMarketingBanner {
      getMarketingBanner(activeOnly: true) {
        id
        title
        image
        link
        buttonText
        campaignStatus
      }
    }
  `, {
    name: 'marketingBanner'
  }),
  graphql(gql`
    query getHomeModulesSettings {
      getHomeModulesSettings {
        modules {
          id
          name
          label
          enabled
          order
        }
      }
    }
  `, {
    name: 'homeModules',
    options: {
      ssr: true,
      fetchPolicy: 'cache-first'
    }
  })
)(Homepage);
